import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import { Loader } from '@src/components/Loader';
import styles from './styles.module.scss';

export interface IUploadingFile {
  id: string
  progress: number
  localUrl: string
  collectionId?: string
}

interface IProps {
  file: IUploadingFile
}

export function UploadingFile({ file }: IProps) {
  return (
    <div className="thumbnail" style={{ backgroundImage: `url("${file.localUrl}")` }}>
      <div className={styles.overlay}>
        <div>
          {file.progress < 100 ? (
            <CircularProgress
              className={styles.progress}
              variant="determinate"
              value={file.progress}
              size={48}
              thickness={4}
            />
          ) : (
            <Loader size={10} />
          )}
        </div>
      </div>
    </div>
  );
}
